/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateOrderRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {CreateOrderResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const createOrder = (request: CreateOrderRequest, options?: CashRequestOptions) => post<CreateOrderRequest, CreateOrderResponse>("/cash-app/local/order", request, {...options, rejectOnError: true })